var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import { Tooltip, Heading, Paragraph } from "@zillow/constellation-10";
import _toPairs from "lodash/toPairs";
import PropTypes from "prop-types";
import { Component } from "react";
import { getWholeDollars } from "../../utils/zhl-calculator.esm.js";
import PropInterpolatorWrapper from "./Chart/common/PropInterpolator.esm.js";
import DonutChart from "./DonutChart.esm.js";
import { seriesColors, textDark } from "./tokens.esm.js";
import withDimensions from "./withDimensions.esm.js";
const MonthlyPILabel = ({
  className,
  style,
  transform,
  "data-label": dataLabel
}) => /* @__PURE__ */ jsxs(Tooltip.Root, { placement: "bottom", children: [
  /* @__PURE__ */ jsx(Tooltip.Trigger, { className, style: {
    ...style,
    cursor: "pointer"
  }, transform, "data-label": dataLabel, role: "button", tabIndex: 0, children: /* @__PURE__ */ jsx("text", { children: "P & I" }) }),
  /* @__PURE__ */ jsx(Tooltip.Portal, { children: /* @__PURE__ */ jsxs(Tooltip.Content, { children: [
    /* @__PURE__ */ jsx(Heading, { level: 4, children: "Principal and Interest" }),
    /* @__PURE__ */ jsx(Paragraph, { children: "Your mortgage principal is the total amount you've borrowed from a lender to buy a home. Interest is the fee lenders charge you for borrowing their money; usually, an annual percentage rate." })
  ] }) })
] });
MonthlyPILabel.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  transform: PropTypes.string,
  "data-label": PropTypes.string,
  // Consumed by `Arc`, not by this component.
  hasUnderline: PropTypes.bool
};
const MonthlyPITooltip = /* @__PURE__ */ jsx(MonthlyPILabel, { hasUnderline: true });
class PaymentDonutChart extends Component {
  constructor() {
    super(...arguments);
    // `seriesColors` has five entries but FHA can need six segments, so the
    // sixth always falls through to `textDark`. Faithful to v8, which fell
    // through to `colors.black` the same way.
    __publicField(this, "colors", (i) => seriesColors[i] || textDark);
  }
  render() {
    const nameMap = {
      monthlyPI: MonthlyPITooltip,
      monthlyPropertyTax: "Taxes",
      monthlyHomeownersInsurance: "Insurance",
      monthlyPMI: "PMI",
      monthlyHOA: "HOA",
      monthlyMIP: this.props.monthlyMIP ? "MIP" : ""
    };
    const usedColorsList = [];
    const getColors = (i) => usedColorsList[i] || textDark;
    const chartData = _toPairs(this.props).filter((item) => !!nameMap[item[0]]).map((item) => ({
      label: nameMap[item[0]],
      value: Math.round(item[1])
    })).filter((element, i) => {
      if (element.value > 0) {
        usedColorsList.push(this.colors(i));
        return true;
      }
      return false;
    });
    let constrainedDimension = 140;
    let radiusRatio = 2.25;
    let height = 140;
    if (!this.props.hideLabels) {
      constrainedDimension = Math.min(this.props.containerWidth, 275) - 30;
      radiusRatio = 3;
      height = 275;
    }
    return /* @__PURE__ */ jsx("div", { style: {
      height
    }, children: /* @__PURE__ */ jsx(DonutChart, { data: chartData, width: this.props.containerWidth, height, radius: constrainedDimension / radiusRatio, innerRadius: constrainedDimension / radiusRatio * 0.87, valueFormatter: getWholeDollars, centerText: "Your payment", colors: getColors, hideLabels: this.props.hideLabels, smallCenterLabel: this.props.smallCenterLabel, centerValue: Math.round(this.props.monthlyPayment) }) });
  }
}
__publicField(PaymentDonutChart, "propTypes", {
  monthlyPayment: PropTypes.number,
  containerWidth: PropTypes.number,
  hideLabels: PropTypes.bool,
  smallCenterLabel: PropTypes.bool
});
const PaymentDonutChart$1 = PropInterpolatorWrapper(withDimensions(PaymentDonutChart, {
  defaultHeight: 275,
  defaultWidth: 347
}));
export {
  PaymentDonutChart$1 as default
};
